import {ordersListFiltersSelector} from "../../../CustomerOrdersListPage/actions/filtersActions";
import {toast} from "react-toastify";
import {
    dataLoaded,
    fetchMainPage,
    fetchPage,
    isLoadingChanged
} from "../../../CustomerOrdersListPage/actions/resultsActions";
import {makeActionCreator} from "../../../../utils";
import {apiFetch} from "../../../../actions/apiActions";

export const DATA_LOADED = "DASHBOARD_CUSTOMER.MAIN_PAGE.DATA_LOADED"
export const CUSTOMER_INFORMATION_LOADED = "DASHBOARD_CUSTOMER.MAIN_PAGE.CUSTOMER_INFORMATION_LOADED"
export const CUSTOMER_DEFAULT_CONTACT_PERSON = "DASHBOARD_CUSTOMER.MAIN_PAGE.CUSTOMER_DEFAULT_CONTACT_PERSON"

export const dataLoad = makeActionCreator(DATA_LOADED, "payload");
export const customerInformationLoad = makeActionCreator(CUSTOMER_INFORMATION_LOADED, "payload");
export const defaultContactPersonLoad = makeActionCreator(CUSTOMER_DEFAULT_CONTACT_PERSON, "payload");


export function loadData(customFilters = null) {
    return async (dispatch, getState) => {
        const filters = ordersListFiltersSelector(getState());
        // dispatch(isLoadingChanged(true));
        try {
            const data = await dispatch(fetchMainPage(customFilters ? customFilters : filters.page));
            if (!data) return;
            // we can prefetch the next page
            // dispatch(fetchPage(filters.page + 1));

            // dispatch(dataLoaded(data.totalRows, data.rows));
            dispatch(dataLoad(data.data));
            dispatch(customerInformationLoad(data.customerInformation));
            dispatch(defaultContactPersonLoad(data.defaultContactPerson))
        } catch (e) {
            console.error(e);
            // toast("Failed to load orders: " + e.message, { type: "error" });
        }
    };
}

export function setOrderImage(orderId, image) {
    return async(dispatch) => {
        try {
            let resp = await dispatch(
                apiFetch(`/api/orders/${orderId}/image`, {
                    method: "PUT",
                    body: JSON.stringify({
                        image
                    })
                })
            );
            let data = await resp.json();
            if (resp.status !== 200) {
                throw new Error(data.message || "Unknown error");
            }
        } catch (e) {
            toast(e.message, {type: "error"});
        }
    }
}

export function updateOfficialOrderName(orderId, name) {
    return async(dispatch) => {
        try {
            let resp = await dispatch(
                apiFetch(`/api/orders/${orderId}/officialOrderName`, {
                    method: "PUT",
                    body: JSON.stringify({
                        officialName: name
                    })
                })
            );
            let data = await resp.json();
            if (resp.status !== 200) {
                throw new Error(data.message || "Unknown error");
            }
        } catch (e) {
            toast(e.message, {type: "error"});
        }
    }
}